import {
  POI_ERROR,
  POI_REQUEST,
  POI_SUCCESS,
} from './types';

const initialState = {
  data   : null,
  error  : null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case POI_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case POI_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case POI_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    default:
      return state;
  }
}
